<mat-icon class="close" (click)="close()">close</mat-icon>
<div class="container-fluid pt-2">
    <form #initiateForm="ngForm">
        <div class="row">            
            <div class="input-group-prepend">
                <span class="input-group-text">{{object.name}} values</span>
            </div>
            <mat-list role="list" *ngFor="let value of tempValues">
                <mat-list-item role="listitem">{{value}}</mat-list-item>
                <mat-icon class="mat-icon-clear" title="Delete value" (click)="deleteValue(value)" style="transform: scale(.75);">
                    delete
                </mat-icon>
            </mat-list>
            <!-- <div *ngIf="isErrorOnMetadata" class="col-6" style="color: red; padding-top: 0.2rem">
                {{errorMessage}}
            </div> -->
        </div> 
        <div class="row">
            <div class="input-group-prepend">
                <span class="input-group-text">{{object.name}} *</span>
            </div>
            <textarea placeholder="Enter the new value" class="textarea-waterrightid" matInput [(ngModel)]="object.value" name="{{object.name}}"></textarea>
            <div *ngIf="object.error.flag" style="color: red; padding-top: 0.2rem">
                {{object.error.message}}
            </div>
        </div>
        <div class="row">
            <div>
                <button mat-raised-button (click)="addValue()" class="actionButton m-2" style="float: right"
                    >Add</button>
            </div>
        </div>
    </form>
    <div>
        <button mat-raised-button (click)="updateQuery()" class="actionButton m-2" style="float: right">Save</button>
        <button mat-raised-button (click)="onClose()" class="backButton m-2" style="float: right">Close</button>
    </div>
</div>